export default {
  // Logo/spectrum
  RED: "#c10c1a",
  YELLOW: "#ffd500",

  // Primary
  ORANGE_DARK: "#f36d00",
  ORANGE_DARK_HOVER: "#ed5a02",
  ORANGE_LIGHT: "#f8ab08",

  // Secondary
  PURPLE_DARK: "#671e75",
  PURPLE_LIGHT: "#a88ab5",
  BLUE_DARK: "#0077c8",
  BLUE_LIGHT: "#62b5e5",
  GREEN_DARK: "#007632",
  GREEN_LIGHT: "#a5bb48",

  // Greys
  CHARCOAL: "#2a2a2a",
  CHARCOAL_HOVER: "#000000",
  CHARCOAL_BODY: "#666666",
  CHARCOAL_MUTED: "#767676",
  CHARCOAL_MEDIUM: "#777777",
  CHARCOAL_LIGHT: "#aaaaaa",
  GREY: "#d8d8d8",
  GREY_MEDIUM: "#eeeeee",
  GREY_LIGHT: "#f4f4f4",
  WHITE: "#FFFFFF"
};
